import React from "react";

export const RightArrowIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <rect x="1" y="1" width="34" height="34" rx="6" stroke="currentColor" fill="none" data-arrow-border />
    <path d="M16 12L22 18L16 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" data-arrow-icon />
  </svg>
);
